module.exports = __webpack_public_path__ + "files/d5209d654b04b0fccafa66835bf1539a.png";